<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 mt-2 pb-2 bgsecond">

                <div class="row   text-light">

                    <div class="col-md-10 offset-1">

                        <div class="row ">
                            <h1 class=" mt-1 col-md-4 offset-5">
                                <span v-if="actiontype=='Save'">Add</span>
                                <span v-if="actiontype=='Update'">Update</span>
                                 Branch </h1>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Branch Name <span class="text-danger">*</span></label>
                                <b-form-input v-model="form.name" placeholder="Enter branch name"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Short Code</label>
                                <b-form-input v-model="form.short_code" placeholder="Enter short code"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Franchise</label>
                                <v-select
                                    v-model="selectedFranchisee"
                                    class="text-dark"
                                    placeholder="Select Franchise"
                                    :options="franchiseeOptions"
                                    label="f_name"
                                    :reduce="option => option.id"
                                />
                            </div>
                        </div>

                        <hr class="bg-light" />

                        <div class="row mt-3">
                            <h5 class="col-md-12">Address Details</h5>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-6">
                                <label for="" class="form-label">Address Line 1</label>
                                <b-form-input v-model="form.addressLine1" placeholder="Enter address line 1"></b-form-input>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Address Line 2</label>
                                <b-form-input v-model="form.addressLine2" placeholder="Enter address line 2"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-4">
                                <label for="" class="form-label">State</label>
                                <b-form-input v-model="form.state" placeholder="Enter state"></b-form-input>
                            </div>
                            <div class="col-md-4">
                                <label for="" class="form-label">Postcode</label>
                                <b-form-input v-model="form.postcode" placeholder="Enter postcode"></b-form-input>
                            </div>
                            <div class="col-md-4">
                                <label for="" class="form-label">Tel</label>
                                <b-form-input v-model="form.tel" placeholder="Enter telephone"></b-form-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="" class="form-label">Email</label>
                                <b-form-input v-model="form.email" type="email" placeholder="Enter email"></b-form-input>
                            </div>
                        </div>

                        <hr class="bg-light" />

                        <div class="row mt-3" v-if="actiontype=='Save'">
                            <div class="col-md-12">
                                <b-form-checkbox v-model="createLocation" class="text-light">
                                    <strong>Create Associated Location</strong>
                                </b-form-checkbox>
                            </div>
                        </div>

                        <div class="row " style="margin-top: 40px;">
                            <div class="col-md-4 offset-4">
                                <button  type="button" class="btn custom-btn2 w-100 btn-lg text-light   mt-5 mtmb" @click="save_branch" :disabled="saving || fetching "> <span v-if="actiontype=='Update'" >Update</span>  <span v-if="actiontype=='Save'">Save</span> </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import axios from "axios";
import Swal from "sweetalert2";
import showrealtime from "@/components/showrealtime";
import URL from "@/constants/baseurl"
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import vSelect from "vue-select";


export default {
    name: "branch form",

    components:{Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        actiontype(){
            if (this.$route.query.type=='add'){
                return 'Save'
            }
            else if (this.$route.query.type=='edit'){
                return 'Update'
            }
            else {
                return 'View'
            }
        }

    },
    data() {
        return {
            form:{
                name:'',
                short_code:'',
                addressLine1:'',
                addressLine2:'',
                state:'',
                postcode:'',
                tel:'',
                email:'',
            },
            selectedFranchisee: null,
            franchiseeOptions: [],
            createLocation: false,
            saving:false,
            fetching:false,

        };
    },
    async created() {
        this.viewType = this.$route.query.type;
        this.branch_id = this.$route.query.id;
        await this.fetchFranchisees();
        if(this.viewType !== 'add'){
            await this.setBranch();
        }

    },
    async mounted() {

    },

    methods: {
        ...mapActions(['login', 'processLogoutManual']),

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        async fetchFranchisees() {
            try {
                const apiToken = localStorage.getItem('token');
                const response = await fetch(`${URL.BASEURL}/api/get-franchisees`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify({ page: 1 })
                });
                const res = await response.json();
                this.franchiseeOptions = res.data || [];
            } catch (error) {
                console.error('Error fetching franchisees:', error);
            }
        },

        async save_branch() {
            if (!this.form.name) {
                Swal.fire('Error', 'Branch Name is required.', 'error');
                return;
            }
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }

            this.saving=true
            try {
                let branchPayload = { ...this.form };
                branchPayload.franchisee_id = this.selectedFranchisee;
                branchPayload.create_location = this.createLocation;

                let api_url=`${URL.BASEURL}/api/add-branch`
                if(this.branch_id){
                    api_url=`${URL.BASEURL}/api/update-branch/${this.branch_id}`
                }
                await axios.post(api_url, branchPayload);

                if(this.branch_id){
                    await Swal.fire('Success', 'Branch updated successfully!', 'success');
                } else {
                    await Swal.fire('Success', 'Branch created successfully!', 'success');
                }

                this.$router.push({ path: '/branch-management' })

            } catch (error) {
                console.error("Error saving branch:", error);
                Swal.fire('Error', 'Failed to save branch.', 'error');
            }
            finally {
                this.saving=false
            }
        },

        async setBranch(){
            this.fetching=true
            const {data} = await apiService.get(`/get-branch/${this.branch_id}`);

            this.form.name=data.name;
            this.form.short_code=data.short_code;
            this.form.addressLine1=data.addressLine1;
            this.form.addressLine2=data.addressLine2;
            this.form.state=data.state;
            this.form.postcode=data.postcode;
            this.form.tel=data.tel;
            this.form.email=data.email;
            this.selectedFranchisee = data.franchisee_id;

            this.fetching=false
        },
    }
};
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
